// const dispatchAxiosUpdatedEvent = require('../modules/api/axios-updated-event.js').default;
const handleRequest = require('../modules/api/handle-request.js').default;
const handleError = require('../modules/api/handle-error.js').default;
const handleSuccess = require('../modules/api/handle-success.js').default;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
// window.axiosUpdatedEvent = new Event('axiosUpdate');

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
	window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
	// console.log('CSRF token attached to axios: ' + token.content);
} else {
	console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Setup of Axios Interceptors for global functions to be called on all requests
 * or responses.
 * See: https://dev.to/teroauralinna/global-http-request-and-response-handling-with-the-axios-interceptor-30ae
 */

// const TOASTTIMEOUT = 4000;
// let handlerEnabled = true;
window.debug = {};
window.debug.axios = {};
window.debug.axios.requests = [];

// Checks if handlerEnabled configuration variable is set to false to customize use of interceptors
// for any API call specifically.
const isHandlerEnabled = (config = {}) => {
	return Object.prototype.hasOwnProperty.call(config, 'handlerEnabled') && !config.handlerEnabled ? false : true;
};

// Sets up the global function to be run before each Axios API request.
const requestHandler = request => {
	if (isHandlerEnabled(request)) {
		handleRequest(request);
	}
	return request;
};

// Sets up the global function to be run at any failed API request.
const errorHandler = error => {
	if (isHandlerEnabled(error.config)) {
		handleError(error);
	}
	return Promise.reject({ ...error });
};

// Sets up the global function to be run at any successfull API request.
const successHandler = response => {
	if (isHandlerEnabled(response.config)) {
		handleSuccess(response);
	}
	return response;
};

// Add interceptors
window.axios.interceptors.request.use(request => requestHandler(request));

window.axios.interceptors.response.use(
	response => successHandler(response),
	error => errorHandler(error)
);
